import { FC } from "react";

// Styles
import { Checkmark } from "@carbon/icons-react";

// Components
import { Box } from "@mui/material";


interface _SelectBoxProps {
    isSelected: boolean;
    isDisabled?: boolean;
    onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
    onMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
}

const SelectBox: FC<_SelectBoxProps> = ({ 
    isSelected,
    isDisabled = false,
    onMouseEnter,
    onMouseLeave
}) => {

    const boxColor = () => {
        if (isDisabled) return 'var(--border-disabled)';
        return isSelected ? 'var(--text-primary)' : 'var(--layer-01)';
    }

    const borderColor = () => {
        if (isDisabled) return 'var(--border-disabled)';
        return isSelected ? 'var(--text-primary)' : 'var(--border-subtle-01)';
    }

    return (
        <Box 
            className='Recipe__selectable'
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            sx={{
                position: 'absolute',
                top: 0, left: 0, m: 1,
                cursor: 'pointer',
            }}>
                <Box 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    border="solid 1px" 
                    borderColor={borderColor()}
                    borderRadius="4px" 
                    boxSizing="border-box"
                    width="16px" height="16px" 
                    sx={{backgroundColor: boxColor()}}
                    >
                    {isSelected && <Checkmark size={16} style={{color: 'var(--text-on-color)'}} />}
                </Box>
            
        </Box>
    );
}

export default SelectBox;